export default class BaseView {
	constructor(container) {
		this.container = container;
		this.modules = new Map();
	}

	createModules(groups) {
		groups.forEach((elements, type) => {
			elements.forEach(element => {
				this.modules.set(element, new type(element));
			});
		});
	}

	destroy() {
		this.modules.forEach(module => {
			if (typeof module.destroy !== 'function') {
				return;
			}

			module.destroy();
		});
	}
}
